module.exports = __webpack_public_path__ + "img/guihuamiou.1e658ff2.jpg";